<template>
<div class="fbpContainer" v-if="!reply">
    
    <div class="fbpHeader">
        <div class="fbpProfileImg" :style="profile_img"></div>
        <div class="fbpTags">
            <div class="fbpAccountName">
                {{authorName}}
                <img v-if="verified" src="/img/facebook-verified.png" />
            </div>
            <div class="fbpPostTime">{{post_time}}</div>
        </div>
        <div class="fbpDelete" v-if="edit" @click="removePost">
            <i class="fas fa-trash-alt" style="color: #ed5338" />
        </div>
    </div>
    
    <div class="fbpBody">
        <div class="fbpBodyText">{{text}}</div>
        <div class="fbpMeta" v-if="!queued">
            <!-- <div class="fbpMetaReactions">
                <div class="fbpLike"></div>
                <div class="fbpLikeCount">46K</div>
            </div> -->
            <div class="fbpMetaComments">{{replies.length}} kommentar</div>
        </div>
    </div>
    
    <div class="fbpFooter" v-if="!queued">

        <FacebookPost v-for="fb in replies" :key="fb.post_id" :publishTime="fb.publish_time_ts"
            :authorName="fb.account_name" :authorHandle="fb.account_handle" 
            :verified="fb.verified" :imageUrl="fb.image_url" :text="fb.text" 
            :sender="fb.sender" :edit="edit" :post_id="fb.post_id" :reply="true" @removePost="removePost" />

        <div class="fbpComment">
            <div class="fbpCommentImg" :style="comment_img"></div>
            <TextareaAutosize ref="commentTextarea" v-model="comment_text" :disabled="disabled" placeholder="Skriv en kommentar..." rows="1" class="fbpCommentText" :class="{participant: !edit, dashboard: edit}" :min-height="24" />
            <!-- <div class="fbpCommentText">Skriv et kommentar...</div> -->
            <div class="fbpCommentSend" @click="sendReply">
                <i class="fas fa-reply fbpCommentSendIcon" />
            </div>
        </div>
    </div>

</div>

<div class="fbpContainer fbpReply" v-else>
    <div class="fbpHeader">
        <div class="fbpProfileImg" :style="profile_img"></div>
        <div class="fbpTags">
            <div class="fbpAccountName">
                {{authorName}}
                <img v-if="verified" src="/img/facebook-verified.png" />
            </div>
            <div class="fbpPostTime">{{text}}</div>
        </div>
        <div class="fbpDelete" v-if="edit" @click="removePost">
            <i class="fas fa-trash-alt" style="color: #ed5338" />
        </div>
    </div>
</div>

</template>

<script>
import Vue from 'vue'
import TextareaAutosize from 'vue-textarea-autosize'
import dayjs from 'dayjs';
import FacebookPost from './FacebookPost';
import { mapGetters, mapState } from 'vuex';
Vue.use(TextareaAutosize)

export default {
    name: 'FacebookPost',
    components: {
        FacebookPost
    },
    props: {
        post_id: Number,
        parent_post_id: Number,
        authorName: String,
        authorHandle: String,
        verified: Boolean,
        text: String,
        sender: String,
        imageUrl: String,
        publishTime: Number,
        edit: Boolean,
        queued: Boolean,
        reply: Boolean,
        pgroup_id: Number,
        disabled: Boolean
    },
    data(){
        return {
            time_since_publish: '',
            comment_text: ''
        }
    },
    computed: {
        ...mapGetters({
            posts: 'getPubPosts'
        }),
        ...mapState({
            instance_id: state => state.curr_instance,
            project_id: state => state.curr_project,
            curr_pgroup_id: state => state.curr_pgroup.pgroup_id,
            pgroup_name: state  => state.curr_pgroup.name,
            gamemaster_id: state => state.gamemaster.gamemaster_id
        }),
        ...mapState({
            gamemaster_id: state => state.gamemaster.gamemaster_id
        }),
        profile_img() { return 'background-image: url(' + (this.imageUrl? this.imageUrl: '/img/facebook-default.jpg') + ');' },
        comment_img() { 
            if (this.edit && this.$parent.selected_account) return this.$parent.selected_account.avatar
            return 'background-image: url(/img/facebook-default.jpg);'
        },
        replies() {return this.posts.filter(p => p.type == 'facebook' && p.parent_post_id == this.post_id).reverse()},
        reply_empty() {return this.comment_text == ""},
        post_time() {return dayjs.unix(this.publishTime).format('D MMMM YYYY')}
    },
    methods: {
        sendReply() {
            if (this.reply_empty || this.disabled) return
            const user_meta = this.edit ? this.$parent.selected_account : null
            const payload = {
                parent_post_id: this.post_id,
                project_id: this.project_id,
                instance_id: this.instance_id,
                gamemaster_id: this.gamemaster_id,
                text: this.comment_text,
                sender: this.edit? 'gamemaster': 'participant',
                account_name: user_meta? user_meta.name: this.pgroup_name,
                account_handle: user_meta? user_meta.handle: this.pgroup_name.replace(' ', '').toLowerCase(),
                image_url: user_meta? user_meta.image_url: null,
                verified: user_meta? user_meta.verified: true,
                pgroup_id: user_meta? this.pgroup_id: this.curr_pgroup_id,
                queued: false,
                type: 'facebook'
            }
            this.comment_text = ""
            this.$socket.emit('sendPost', payload)
            this.$emit('refreshGenUser')
        },
        removePost: function(post_id=null) {
            isNaN(post_id)? post_id = null: null
            this.$emit('removePost', post_id? post_id: this.post_id)
        },
    }
}
</script>